import { fireSafetyNotificationType } from "common/constant";

const BUILDING_INFORMATION = "BuildingInformation";
const BUILDING_SCHEDULE = "BuildingSchedule";
const OBSERVATION = "Observation";
const DASHBOARD_SCHEDULE = "DashboardSchedule";

export const getNavigateUrlForFireSafetyFromNotification = (
  notificationType,
  notificationTypeId,
  isAdmin = false
) => {
  switch (fireSafetyNotificationType[notificationType]) {
    case BUILDING_INFORMATION:
      return isAdmin
        ? `/fire-safety/admin/building-information?applicationId=${notificationTypeId}`
        : `/fire-safety/my-request/building-applications?applicationId=${notificationTypeId}`;
    case BUILDING_SCHEDULE:
      return isAdmin
        ? `/fire-safety/admin/building-information?auditScheduleId=${notificationTypeId}`
        : `/fire-safety/my-request/building-applications?auditScheduleId=${notificationTypeId}`;
    case OBSERVATION:
      return isAdmin
        ? `/fire-safety/admin/building-information?buildingObservationId=${notificationTypeId}`
        : `/fire-safety/my-request/building-applications?buildingObservationId=${notificationTypeId}`;
    case DASHBOARD_SCHEDULE:
      return `/fire-safety/consumer/dashboard?developerBuildingId=${notificationTypeId}`;
  }
};
